export default __webpack_public_path__ + "static/media/background.31cae173.jpg";